import { createContext } from "react";

export const DashboardSetupContext = createContext(null);
